import { render, staticRenderFns } from "./MedicalBlockMedicine.vue?vue&type=template&id=2295ff3b&"
import script from "./MedicalBlockMedicine.vue?vue&type=script&lang=js&"
export * from "./MedicalBlockMedicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard} from 'quasar'
component.options.components = Object.assign({QCard}, component.options.components || {})
